import { useFormikContext } from "formik";
import { TextField } from "@mui/material";
import { AddClientFormValues } from "../../types";

const ClientNameDetails = () => {
  const { handleChange, values, errors, touched } =
    useFormikContext<AddClientFormValues>();

  return (
    <>
      <TextField
        id="client-name"
        label="Name"
        variant="standard"
        autoComplete="off"
        fullWidth
        value={values["client-name"]}
        onChange={handleChange}
        error={touched["client-name"] && Boolean(errors["client-name"])}
        helperText={touched["client-name"] && errors["client-name"]}
        sx={{ width: "100%", float: "right" }}
      />
    </>
  );
};

export default ClientNameDetails;
